// extracted by mini-css-extract-plugin
export var desktop = "pane-module--desktop--7232f";
export var kotlinlang = "pane-module--kotlinlang--44deb";
export var logo = "pane-module--logo--fcf0e";
export var mobile = "pane-module--mobile--a0d31";
export var nav = "pane-module--nav--ea3f7";
export var pane = "pane-module--pane--1cbe3";
export var paneTop = "pane-module--paneTop--1a3d1";
export var popup = "pane-module--popup--9bc3e";